import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=08f43904&scoped=true&"
import script from "./SectionWrapper.vue?vue&type=script&lang=ts&"
export * from "./SectionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=08f43904&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f43904",
  null
  
)

export default component.exports